import { fromJS } from 'immutable';

export const EFFECTS_DESCRIPTOR_PEOPLE_REQUEST = 'EFFECTS_DESCRIPTOR_PEOPLE_REQUEST';
export const EFFECTS_DESCRIPTOR_PEOPLE_SUCCESS = 'EFFECTS_DESCRIPTOR_PEOPLE_SUCCESS';
export const EFFECTS_DESCRIPTOR_PEOPLE_FAILURE = 'EFFECTS_DESCRIPTOR_PEOPLE_FAILURE';

export const EFFECTS_DESCRIPTOR_HOUSES_REQUEST = 'EFFECTS_DESCRIPTOR_HOUSES_REQUEST';
export const EFFECTS_DESCRIPTOR_HOUSES_SUCCESS = 'EFFECTS_DESCRIPTOR_HOUSES_SUCCESS';
export const EFFECTS_DESCRIPTOR_HOUSES_FAILURE = 'EFFECTS_DESCRIPTOR_HOUSES_FAILURE';

export const EFFECTS_DESCRIPTOR_DAMAGE_REQUEST = 'EFFECTS_DESCRIPTOR_DAMAGE_REQUEST';
export const EFFECTS_DESCRIPTOR_DAMAGE_SUCCESS = 'EFFECTS_DESCRIPTOR_DAMAGE_SUCCESS';
export const EFFECTS_DESCRIPTOR_DAMAGE_FAILURE = 'EFFECTS_DESCRIPTOR_DAMAGE_FAILURE';

const initialState = fromJS({
  people: [],
  peopleFetched: false,
  houses: [],
  housesFetched: false,
  damage: [],
  damageFetched: false,
});

// default param first is the redux convention https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers
// eslint-disable-next-line default-param-last
export const effectsDescriptorReducer = (state = initialState, action) => {
  switch (action.type) {
    case EFFECTS_DESCRIPTOR_PEOPLE_REQUEST:
      return state.merge(fromJS({
        peopleFetched: false,
      }));
    case EFFECTS_DESCRIPTOR_PEOPLE_SUCCESS:
      return state.merge(fromJS({
        peopleFetched: true,
        people: action.response.items,
      }));
    case EFFECTS_DESCRIPTOR_PEOPLE_FAILURE:
      return state.merge(fromJS({
        peopleFetched: true,
      }));

    case EFFECTS_DESCRIPTOR_HOUSES_REQUEST:
      return state.merge(fromJS({
        housesFetched: false,
      }));
    case EFFECTS_DESCRIPTOR_HOUSES_SUCCESS:
      return state.merge(fromJS({
        housesFetched: true,
        houses: action.response.items,
      }));
    case EFFECTS_DESCRIPTOR_HOUSES_FAILURE:
      return state.merge(fromJS({
        housesFetched: true,
      }));

    case EFFECTS_DESCRIPTOR_DAMAGE_REQUEST:
      return state.merge(fromJS({
        damageFetched: false,
      }));
    case EFFECTS_DESCRIPTOR_DAMAGE_SUCCESS:
      return state.merge(fromJS({
        damageFetched: true,
        damage: action.response.items,
      }));
    case EFFECTS_DESCRIPTOR_DAMAGE_FAILURE:
      return state.merge(fromJS({
        damageFetched: true,
      }));


    default:
      return state;
  }
};
